import { useParams } from "react-router-dom"
import { useEffect } from "react"
import { downloadDocumentsQR } from "../Projects/Table/api/download_documents"

export function QRDownload() {
    const { project_id } = useParams()

    useEffect(() => {
        if (project_id) {
            downloadDocumentsQR(project_id)
        }
    }, [project_id])

    return (
        <div>
            <p>Downloading files...</p>
        </div>
    )
}